const getBindingValues = binding => {
  const _values = binding.value || {},
        values  = {};

  if (typeof _values === 'function') {
    values.callback = _values;
  } else if (typeof _values === 'object') {
    values.callback = _values.callback;
    values.outside  = _values.outside;
  }

  if (!values.outside) {
    values.outside = document.documentElement;
  }

  return values;
}

const getPositionByEvent = e => {
  const point = e.changedTouches ? e.changedTouches[0] : e;
  return {x: point.pageX, y: point.pageY};
}

const getLengthByPosition = (startPosition, endPosition, x2 = null, y2 = null) => {
  let x1, y1;
  if (x2 === null) {
    x1 = startPosition.x;
    y1 = startPosition.y;
    x2 = endPosition.x;
    y2 = endPosition.y;
  } else {
    x1 = startPosition;
    y1 = endPosition;
  }
  return Math.sqrt(Math.pow(x2 - x1 , 2) + Math.pow(y2 - y1 , 2));
}

const JUDGE_TAP_CANCEL_RANGE = 44;

export default {
  bind(el, binding, v) {
    v.context.$dn.load(() => {
      const bindingValues = getBindingValues(binding);
      const outside = bindingValues.outside;

      let isTouch       = false,
          isCancel      = false,
          moveLength    = 0,
          startPosition = null;

      const touchStart = e => {
        isTouch    = true;
        isCancel   = false;
        moveLength = 0;
        startPosition = getPositionByEvent(e);
      }

      const touchMove = e => {
        if (!isTouch || !startPosition || isCancel) return;

        const currentPosition = getPositionByEvent(e),
              length          = getLengthByPosition(startPosition, currentPosition);

        moveLength += length;

        if (moveLength >= JUDGE_TAP_CANCEL_RANGE) isCancel = true;
      }

      const touchEnd = e => {
        if (!isTouch || isCancel) return;
        isTouch       = false;
        isCancel      = false;
        startPosition = null;

        let cb = () => true;

        if (bindingValues.callback) cb = bindingValues.callback;

        if (
          v.context.isActive &&
          (e && e.target) &&
          (e.target !== el && !el.contains(e.target)) &&
          cb(e)
        ) {
          if (typeof v.context.hide === 'function') {
            v.context.hide();
          } else {
            v.context.isActive = false;
          }
        }
      }

      outside.addEventListener('touchstart', touchStart, false);
      outside.addEventListener('mousedown', touchStart, false);
      outside.addEventListener('touchmove', touchMove, false);
      outside.addEventListener('mousemove', touchMove, false);
      outside.addEventListener('touchend', touchEnd, false);
      outside.addEventListener('mouseup', touchEnd, false);

      el.touchStartOutside = touchStart;
      el.touchMoveOutside = touchMove;
      el.touchEndOutside = touchEnd;
    })
  },

  unbind(el, binding) {
    const bindingValues = getBindingValues(binding);
    const outside = bindingValues.outside;

    if (outside) {
      outside.removeEventListener('touchstart', el.touchStartOutside, false);
      outside.removeEventListener('mousedown', el.touchStartOutside, false);
      outside.removeEventListener('touchmove', el.touchMoveOutside, false);
      outside.removeEventListener('mousemove', el.touchMoveOutside, false);
      outside.removeEventListener('touchend', el.touchEndOutside, false);
      outside.removeEventListener('mouseup', el.touchEndOutside, false);
    }
  }
}


// WEBPACK FOOTER //
// ./src/js/ui/directives/click-outside.js